const { createSelector } = require('reselect')

const selectShorturlList = state => state.shortUrl.shorturlList

const getShorturlList = () => createSelector(
  [selectShorturlList],
  cse => cse.data,
)

const getShorturlListError = () => createSelector(
  [selectShorturlList],
  cse => cse.error,
)

const getShorturlListLoading = () => createSelector(
  [selectShorturlList],
  cse => cse.loading,
)

const selectShorturl = state => state.shortUrl.shorturl

const getShorturl = () => createSelector(
  [selectShorturl],
  cse => cse.data,
)

const getShorturlError = () => createSelector(
  [selectShorturl],
  cse => cse.error,
)

const getShorturlLoading = () => createSelector(
  [selectShorturl],
  cse => cse.loading,
)

const selectCreate = state => state.shortUrl.create

const getCreateShorturl = () => createSelector(
  [selectCreate],
  cse => cse.data,
)

const getCreateShorturlError = () => createSelector(
  [selectCreate],
  cse => cse.error,
)

const getCreateShorturlLoading = () => createSelector(
  [selectCreate],
  cse => cse.loading,
)
const selectUpdate = state => state.shortUrl.update

const getUpdateShorturl = () => createSelector(
  [selectUpdate],
  cse => cse.data,
)

const getUpdateShorturlError = () => createSelector(
  [selectUpdate],
  cse => cse.error,
)

const getUpdateShorturlLoading = () => createSelector(
  [selectUpdate],
  cse => cse.loading,
)
const selectDelete = state => state.shorturlDomain.delete

const getDeleteShorturl = () => createSelector(
  [selectDelete],
  cse => cse.data,
)

const getDeleteShorturlError = () => createSelector(
  [selectDelete],
  cse => cse.error,
)

const getDeleteShorturlLoading = () => createSelector(
  [selectDelete],
  cse => cse.loading,
)

module.exports = {
  getShorturlList,
  getShorturlListLoading,
  getShorturlListError,
  getShorturl,
  getShorturlLoading,
  getShorturlError,
  getCreateShorturl,
  getCreateShorturlLoading,
  getCreateShorturlError,
  getUpdateShorturl,
  getUpdateShorturlLoading,
  getUpdateShorturlError,
  getDeleteShorturl,
  getDeleteShorturlLoading,
  getDeleteShorturlError,
}
